import {
    array,
    boolean,
    literal,
    nativeEnum,
    object,
    string,
    TypeOf,
} from 'zod';

import { CornerStyle, ElementType } from '../common';

/* ------------------------------- BannerSize ------------------------------- */

export enum BannerSize {
    Small = 'small',
    Medium = 'medium',
    Large = 'large',
    ExtraLarge = 'extra-large',
}

/* ------------------------------ BannerOptions ----------------------------- */

export const BannerOptions = object({
    size: nativeEnum(BannerSize),
    margin: boolean(),
    parallax: boolean(),
    cornerStyle: nativeEnum(CornerStyle),
});

export type BannerOptions = TypeOf<typeof BannerOptions>;

/* ---------------------------- BannerPageElement --------------------------- */

export const BannerPageElement = BannerOptions.deepPartial().extend({
    id: string(),
    type: literal(ElementType.Banner),
    categories: array(string()),
});

export type BannerPageElement = TypeOf<typeof BannerPageElement>;
